export default __webpack_public_path__ + "static/shoepe-14ccba5f7d3212539d919962a91ad38f.jpg";